import { render, staticRenderFns } from "./v6.vue?vue&type=template&id=021fb7d9&scoped=true&"
import script from "./v6.vue?vue&type=script&lang=js&"
export * from "./v6.vue?vue&type=script&lang=js&"
import style0 from "./v6.vue?vue&type=style&index=0&id=021fb7d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021fb7d9",
  null
  
)

export default component.exports